import { Injectable } from '@angular/core';
import { Utymd } from '../entity/Utymd-angular';
import { UtymdServicePkg } from './utymdPkg.service';


@Injectable({
  providedIn: 'root'
})
export class UtymdService extends UtymdServicePkg {
  constructor() {
    super();
  }
  override async validateItem(item: Utymd): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

override async newRecord(newItem: Utymd): Promise<Utymd> {
    await super.newRecord(newItem);
    return newItem;
  }
}
